import axios from "axios";

export default (appUrl, data = {})=>{
    // x-resource-code 获取
    let headers = data.headers || {};
    headers['x-resource-code'] = appUrl['resourceId'] || '';

    if (appUrl.check === false) {
        headers['check'] = false;
    }
    if(appUrl.ContentType==="multipart/form-data"){
      headers['Content-Type'] = "multipart/form-data" 
    }
    console.log('appUrl,headers',appUrl,headers)

    return new Promise((resolve, reject) => {
        axios({
            url: appUrl.path,
            method: appUrl.method,
            params: data.params,
            data: data.data,
            headers: headers,
            baseURL: data.baseURL,
            transformRequest: data.transformRequest,
            transformResponse: data.transformResponse,
            paramsSerializer: data.paramsSerializer,
            timeout: data.timeout,
            withCredentials: data.withCredentials,
            adapter: data.adapter,
            auth: data.auth,
            responseType: data.responseType,
            responseEncoding: data.responseEncoding,
            onUploadProgress: data.onUploadProgress,
            onDownloadProgress: data.onDownloadProgress,
            maxContentLength: data.maxContentLength,
            validateStatus: data.validateStatus,
            maxRedirects: data.maxRedirects,
            socketPath: data.socketPath,
            httpAgent: data.httpAgent,
            httpsAgent: data.httpsAgent,
            proxy: data.proxy,
            cancelToken: data.cancelToken,
            xsrfCookieName: data.xsrfCookieName,
            xsrfHeaderName: data.xsrfHeaderName  
        })
        .then((res) => {
            if (res && res.data) {
                resolve(res.data);
            }
            else {
                resolve(res);
            }
        })
        .catch((error) => {
            reject(error);
        });
    })
}